import {castArray, isEmpty, isNil} from 'lodash-es';

import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export class MaxItemsValidator {
  public static readonly maxItemsError = 'maxItems';

  public static maxItems(maxLimit: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const {value} = control;

      if (MaxItemsValidator.isEmptyInputValue(value)) {
        return null;
      }

      const controlValues = castArray(value);
      const limitExceededIdx = MaxItemsValidator.getLimitExceededIdx(controlValues, maxLimit);

      return controlValues.length > maxLimit ? {
        [MaxItemsValidator.maxItemsError]: {actualQuantity: controlValues.length, maxLimit, limitExceededIdx}
      } : null;
    };

  }

  private static isEmptyInputValue(value: any): boolean {
    return isNil(value) || isEmpty(value);
  }

  private static getLimitExceededIdx(value: string[], maxLimit: number): number[] {
    const idx = [];

    value.forEach((el, i) => {
      if (i > maxLimit - 1) {
        idx.push(i);
      }
    });

    return idx;
  }
}
